import { pick, serverMap } from '@/shared/lib/server-map'
import type { BookingDetail } from '@/shared/api'

export type BookingDetailRow = BookingDetail['details'][number]
export type DetailTone = NonNullable<BookingDetailRow['tone']>

/**
 * Тон строки деталей → CSS-токен точки-индикатора.
 *
 * Состояние приезжает СВОИМ полем, а не выводится из человеческой строки: захардкоженная точка у
 * `key === 'crm'` осталась бы зелёной над словом «не связан», а разбор `value` погас бы на здоровой
 * связи в день, когда копирайт сменят на «привязан».
 *
 * Инвариант контракта: сервер отдаёт СМЫСЛ, палитру выбирает фронт. Токены те же, что у
 * `eventToneToken` (`entities/conversation/model/timeline.ts`) — одинаковый смысл красится одинаково.
 */
const TONE_TOKENS = serverMap({
  success: 'var(--st-in)',
  warning: 'var(--st-pending)',
  danger: 'var(--st-cancel)',
  neutral: 'var(--ink-3)',
} satisfies Record<DetailTone, string>)

const TONE_FALLBACK = 'var(--ink-3)'

/**
 * Токен точки — или `null`, если точки нет вовсе.
 *
 * ⚠️ ДВА РАЗНЫХ «НЕТ», И ПУТАТЬ ИХ НЕЛЬЗЯ. `null`/отсутствие поля — точки НЕТ (так сказано в
 * контракте; у строк «Объект» и «Город» её и в макете не нарисовано). Незнакомый тон — точка ЕСТЬ,
 * но серая: сервер сообщил, что состояние есть, и прятать его значило бы терять сказанное.
 */
export function detailToneToken(tone: DetailTone | null | undefined): string | null {
  if (!tone) return null
  return pick(TONE_TOKENS, tone, TONE_FALLBACK)
}

/*
 * ⚠️ КАРТЫ «СТРОКА ДЕТАЛЕЙ → КЛЮЧ РЕЕСТРА» ЗДЕСЬ НЕТ, и завести её не подо что. Единственным
 * потребителем была строка «Тариф», а тариф в системе ЗАДУМАН, но не реализован нигде: в домене
 * броней его нет вовсе, цены и тарифы отнесены в будущий сервис (эскиз квартир: «живут в
 * bookings/pricing-service»). Данных не существует — значение сочинял наш стенд.
 *
 * Понадобится пер-строчный бейдж снова — матчиться на `key`, а не на `label`, и только через
 * `serverMap`/`pick`. Ключ лежит в контракте именно для этого: `label` — «текст для глаз, сервер
 * вправе переименовать» (`description` у `details[].key` в `openapi/components/schemas/booking.yaml`),
 * и бейдж на подписи исчез бы молча.
 */
